import moment from 'moment'
import { api } from '@/helpers/interceptors'
import router from '@/router'

import {
  CREATE_JOB,
  UPDATE_JOB,
  UPDATE_STORE_DETAIL,
  DELETE_JOB,
  GET_JOB_LIST,
  GET_JOB_DETAIL,
  GET_STORE_DETAIL,
  GET_STORE_DETAIL_LOG,
  GET_ALL_ACTIVITY,
} from '@/constants/path'

const state = () => ({
  jobList: null,
  jobDetail: null,
  storeDetail: null,
  storeDetailLog: null,
  selectDate: [
    moment().format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD'),
  ],
  activity: null,
  isError: false,
  isLoading: false,
  searchStoreDetail: '',
  statusStoreDetail: null,
  searchJobDetail: '',
  statusJobDetail: null,
  storeDetailTab: 0,
  searchStoreDetailOver: '',
})

// getters
const getters = {}

// actions
const actions = {
  //Create or Post
  async createJob({ state, commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      let bodyFormData = new FormData()

      if (payload?.bu_id && payload['store_ids[]']?.length < 1) {
        bodyFormData.append('bu_id', payload?.bu_id)
      }
      if (payload['job_date[]']) {
        for (let item of payload['job_date[]']) {
          bodyFormData.append('job_date[]', item)
        }
      }
      if (payload?.job_name) {
        bodyFormData.append('job_name', payload?.job_name)
      }
      if (payload?.start_time) {
        bodyFormData.append('start_time', payload?.start_time)
      }
      if (payload?.end_time) {
        bodyFormData.append('end_time', payload?.end_time)
      }
      if (payload['store_ids[]']) {
        for (let item of payload['store_ids[]']) {
          bodyFormData.append('store_ids[]', item)
        }
      }
      if (payload['product_brands[]']) {
        for (let item of payload['product_brands[]']) {
          bodyFormData.append('product_brands[]', item)
        }
      }
      if (payload['categories[]']) {
        for (let item of payload['categories[]']) {
          bodyFormData.append('categories[]', item)
        }
      }
      if (payload['sub_cats[]']) {
        for (let item of payload['sub_cats[]']) {
          bodyFormData.append('sub_cats[]', item)
        }
      }
      if (payload['sku']) {
        const sku = payload['sku']
        sku.reduce((acc, item) => {
          return `${acc},${item}`
        }, [])
        if (sku?.length > 0) bodyFormData.append('sku', sku)
      }
      if (payload['main_ratio']) {
        bodyFormData.append('main_ratio', payload['main_ratio'])
      }
      if (payload['filter_position']) {
        bodyFormData.append(
          'filter_position',
          payload['filter_position'],
        )
      }
      if (payload['sort_fifo']) {
        bodyFormData.append('sort_fifo', payload['sort_fifo'])
      }
      await api(CREATE_JOB, 'post', bodyFormData)
      dispatch('getJoblist', {
        startDate: state?.selectDate?.[0],
        endDate: state?.selectDate?.[1],
      })
      router.push({
        name: 'Dashboard',
      })
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },
  async updateJob({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      let bodyFormData = new FormData()

      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.job_name) {
        bodyFormData.append('job_name', payload?.job_name)
      }
      if (payload?.start_time) {
        bodyFormData.append('start_time', payload?.start_time)
      }
      if (payload?.end_time) {
        bodyFormData.append('end_time', payload?.end_time)
      }
      if (payload['product_brands[]']) {
        for (let item of payload['product_brands[]'].filter(
          (i) => i != 'null' && i !== 'ทั้งหมด',
        )) {
          if (item) {
            bodyFormData.append('product_brands[]', item)
          }
        }
      }
      if (payload['categories[]']) {
        for (let item of payload['categories[]'].filter(
          (i) => i != 'null' && i !== 'ทั้งหมด',
        )) {
          if (item) {
            bodyFormData.append('categories[]', item)
          }
        }
      }
      if (payload['sub_cats[]']) {
        for (let item of payload['sub_cats[]'].filter(
          (i) => i != 'null' && i !== 'ทั้งหมด',
        )) {
          if (item) {
            bodyFormData.append('sub_cats[]', item)
          }
        }
      }
      if (payload['sku']) {
        const sku = payload['sku']
        sku.reduce((acc, item) => {
          return `${acc},${item}`
        }, [])
        if (sku?.length > 0) bodyFormData.append('sku', sku)
      }
      await api(UPDATE_JOB, 'post', bodyFormData)
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },
  async updateStoreDetail({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      let bodyFormData = new FormData()

      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.store_id) {
        bodyFormData.append('store_id', payload?.store_id)
      }
      if (payload?.start_time) {
        bodyFormData.append('start_time', payload?.start_time)
      }
      if (payload?.end_time) {
        bodyFormData.append('end_time', payload?.end_time)
      }
      if (payload['product_brands[]']) {
        for (let item of payload['product_brands[]'].filter(
          (i) => i != 'null' && i !== 'ทั้งหมด',
        )) {
          if (item) {
            bodyFormData.append('product_brands[]', item)
          }
        }
      }
      if (payload['categories[]']) {
        for (let item of payload['categories[]'].filter(
          (i) => i != 'null' && i !== 'ทั้งหมด',
        )) {
          if (item) {
            bodyFormData.append('categories[]', item)
          }
        }
      }
      if (payload['sub_cats[]']) {
        for (let item of payload['sub_cats[]'].filter(
          (i) => i != 'null' && i !== 'ทั้งหมด',
        )) {
          if (item) {
            bodyFormData.append('sub_cats[]', item)
          }
        }
      }
      if (payload['sku']) {
        const sku = payload['sku']
        sku.reduce((acc, item) => {
          return `${acc},${item}`
        }, [])
        if (sku?.length > 0) bodyFormData.append('sku', sku)
      }

      await api(UPDATE_STORE_DETAIL, 'post', bodyFormData)
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },
  async deleteJob({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      let bodyFormData = new FormData()

      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }

      await api(DELETE_JOB, 'post', bodyFormData)
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },
  // Get
  async getJoblist({ commit }, { startDate, endDate, buIds }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const params = {
        start_date: startDate,
        end_date: endDate,
        bu_ids: buIds,
      }

      const res = await api(GET_JOB_LIST, 'get', { params })

      commit('SET_JOBLIST', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_JOBLIST', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getJobDetail({ commit }, { id }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const params = {
        job_id: id,
      }

      const res = await api(GET_JOB_DETAIL, 'get', { params })

      res?.data?.data?.stores?.map((i) => {
        if (
          !i?.product_brand &&
          !i?.category &&
          !i?.sub_cat &&
          !i?.sku
        ) {
          i.product_brand = i?.product_brand ?? 'ทั้งหมด'
          i.category = i?.category ?? 'ทั้งหมด'
          i.sub_cat = i?.sub_cat ?? 'ทั้งหมด'
        }
      })
      commit('SET_JOBDETAIL', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_JOBDETAIL', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getStoreDetail({ commit }, { id, storeId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const params = {
        job_id: id,
        store_id: storeId,
      }

      let res = await api(GET_STORE_DETAIL, 'get', { params })
      const current_stock = res?.data?.data?.current_stock?.map(
        (j) => {
          return {
            amount: j?.amount ?? '0',
            amount_checked: j?.amount_checked ?? '0',
            category: j?.category ?? '',
            check_by: j?.check_by ?? '',
            created_timestamp: j?.created_timestamp ?? '',
            description: j?.description ?? '',
            description_type: j?.description_type ?? '',
            image_url: j?.image_url ?? '',
            image_url2: j?.image_url2 ?? '',
            image_url3: j?.image_url3 ?? '',
            name: j?.name ?? '',
            product_brand: j?.product_brand ?? '',
            sku: j?.sku ?? '',
            sub_cat: j?.sub_cat ?? '',
            updated_timestamp: j?.updated_timestamp ?? '',
            serial_list: j?.serial_list ?? [],
            is_scan_barcode: j?.is_scan_barcode ?? null,
            status: j?.status ?? null,
            stock_in: j?.stock_in ?? '',
          }
        },
      )
      const over_stock = res?.data?.data?.over_stock ?? []
      res.data.data.current_stock = current_stock
      res.data.data.over_stock = over_stock
      commit('SET_STOREDETAIL', res.data.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_STOREDETAIL', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getAllActivity({ commit }, { id, storeId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const params = {
        job_id: id,
        store_id: storeId,
      }

      const res = await api(GET_ALL_ACTIVITY, 'get', { params })

      commit('SET_ACTIVITY', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_ACTIVITY', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getStoreDetailLog({ commit }, { id, storeId, sku }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const params = {
        job_id: id,
        store_id: storeId,
        sku: sku,
      }

      const res = await api(GET_STORE_DETAIL_LOG, 'get', { params })

      commit('SET_STOREDETAIL_LOG', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_STOREDETAIL_LOG', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
}

// mutations
const mutations = {
  SET_ERROR(state, payload) {
    state.isError = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_JOBLIST(state, payload) {
    state.jobList = payload
  },
  SET_JOBDETAIL(state, payload) {
    state.jobDetail = payload
  },
  SET_STOREDETAIL(state, payload) {
    state.storeDetail = payload
  },
  SET_STOREDETAIL_LOG(state, payload) {
    state.storeDetailLog = payload
  },
  SET_ACTIVITY(state, payload) {
    state.activity = payload
  },
  SET_SELECT_DATE(state, payload) {
    state.selectDate = payload
  },
  SET_SEARCH_STORE_DETAIL(state, payload) {
    state.searchStoreDetail = payload
  },
  SET_STATUS_STORE_DETAIL(state, payload) {
    state.statusStoreDetail = payload
  },
  SET_SEARCH_JOB_DETAIL(state, payload) {
    state.searchJobDetail = payload
  },
  SET_STATUS_JOB_DETAIL(state, payload) {
    state.statusJobDetail = payload
  },
  SET_STORE_DETAIL_TAB(state, payload) {
    state.storeDetailTab = payload
  },
  SET_SEARCH_STORE_DETAIL_OVER(state, payload) {
    state.searchStoreDetailOver = payload
  },
  RESET_JOB_DETAIL(state) {
    state.searchJobDetail = ''
    state.statusJobDetail = null
  },
  RESET_STORE_DETAIL(state) {
    state.searchStoreDetail = ''
    state.statusStoreDetail = null
  },
  RESET_STORE_DETAIL_OVER(state) {
    state.searchStoreDetailOver = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
